import { styled } from 'styled-components';

export const LoadingMessage = styled.div`
  color: #2d3748;
  padding: 20px;
`;

export const ErrorMessage = styled.div`
  color: #c53030;
  padding: 20px;
  background-color: #fee;
  border-radius: 5px;
  border: 1px solid #fc8181;
  margin: 20px;
`;
